import React from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components'
import usePortal from '../../utils/usePortal'

const ModalStyle = styled.div`
  font-size: 2rem;
  position: fixed;
  width: 100%;
  height: 100vh;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  z-index: 1000;
  overflow-y: auto;
`

const ButtonClose = styled.div`
  position: fixed;
  top: 2%;
  right: 4%;
  color: var(--color-underline);
  outline: none;
  border: none;
  border-radius: 50%;
  padding: 0.5rem;
  cursor: pointer;
  font-size: 2rem;
  text-align: center;
  i {
    width: 32px;
  }
  &:hover {
    background-color: var(--color-reverse);
  }

  @media only screen and (max-width: 1126px) {
    right: 1%;
  }

  @media only screen and (max-width: 767px) {
    top: 1%;
    right: 3%;
  }
`

const Modal = ({ id, children, exitCallback }) => {
  const target = usePortal(id)
  return createPortal(
    <ModalStyle id="modal">
      <ButtonClose onClick={exitCallback}>
        <i className="fas fa-times"></i>
      </ButtonClose>
      {children}
    </ModalStyle>,
    target
  )
}

export default Modal
